// removed by extract-text-webpack-plugin
module.exports = {"Option":"Option__Option__3K-Bw","OptionAnswer":"Option__OptionAnswer__LbiND","ChatBox":"Option__ChatBox__1Pk39","User":"Option__User__2JGg1","UserImage":"Option__UserImage__PmM3l","UserImageDummy":"Option__UserImageDummy__3hkrE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Option/Option.css
// module id = 82
// module chunks = 0